import { environment } from '@admin-env/environment';
import { AuctionAsset } from '../models/auction-asset';

export class AssetMapper {
  public static mapItems(
    assets: AuctionAsset[] | undefined,
    auctionId: string | undefined
  ): AuctionAsset[] {
    assets = (assets || []).filter((a) => a.url);
    return assets.map((a) => AssetMapper.mapItem(a, auctionId));
  }
  public static mapItem(
    asset: AuctionAsset,
    auctionId: string | undefined
  ): AuctionAsset {
    if (asset.url)
      asset.imageUrl = AssetMapper.completeAssetUrl(asset.url, auctionId);
    return asset;
  }
  public static completeAssetUrl(
    url: string,
    auctionId: string | undefined
  ): string {
    if (!auctionId) return 'assets/images/no-image-available.png';
    return `${environment.ASSETS_URL}/${auctionId}/${url}`;
  }
}
